var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMysafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 23
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDF7FF",
    stroke: "#0874CE",
    d: "M78.534 1.2H7.662a3.49 3.49 0 00-2.47 1.02 3.489 3.489 0 00-1.03 2.468L4.11 18.696a3.486 3.486 0 001.018 2.477A3.48 3.48 0 007.6 22.202l71 .187a3.482 3.482 0 002.468-1.034 3.486 3.486 0 001.016-2.478l-.051-14.19a3.49 3.49 0 00-1.03-2.466 3.488 3.488 0 00-2.47-1.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF7FF",
    d: "M4 10h4v5H4z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Lato-Black, Lato",
    fontSize: 10,
    fontWeight: 700,
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 15.4,
    fill: "#008CFF"
  }, "My"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.92,
    y: 15.4,
    fill: "#4A4A4A"
  }, "Safety")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#008CFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0874CE",
    d: "M10.849 0H22v22H10.849z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.89 3.918c1.922.998 4.18 1.473 6.068 1.607v5.617c0 1.499-.143 2.569-.874 3.604-.88 1.247-2.587 2.421-5.208 3.579l.014-.006c-.002.005-.005.004-.007.003l-.007.003c-2.607-1.162-4.306-2.335-5.182-3.579-.73-1.035-.872-2.105-.872-3.604V5.525c1.89-.135 4.148-.612 6.068-1.607l-.014.007c.002-.006.005-.005.007-.004l.007-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M9.972 11.528L8.4 9.957l-.866.865 2.438 2.438.77-.768 3.487-3.489-.865-.866-2.622 2.622z"
  })))));
}
export default SvgMysafety;